import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {useRoute} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'MaiALauncher',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(route).name !== 'maia')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: "maia-launcher",
        to: {name: 'maia'},
        "aria-label": "Open MaiA, the Mergerfilers AI assistant",
        title: "Ask MaiA"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", {
            class: "material-symbols-outlined",
            "aria-hidden": "true"
          }, "chat_bubble", -1)
        ]))]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})